import { render, staticRenderFns } from "./AbcCurveCustomers.vue?vue&type=template&id=dd0432f8"
import script from "./AbcCurveCustomers.vue?vue&type=script&lang=js"
export * from "./AbcCurveCustomers.vue?vue&type=script&lang=js"
import style0 from "./AbcCurveCustomers.vue?vue&type=style&index=0&id=dd0432f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports